export const iconFontAwesomeScienceEyeDropper = (
	<i className="fa-solid fa-eye-dropper"></i>
);
